'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _urlSearchParams = require('@ungap/url-search-params');

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleChange(_ref, searchParams) {
  var target = _ref.target;

  searchParams.set('sort_by', target.value);
  window.location.search = searchParams.toString();
}

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var sortButtons = context.getElements('.' + context.className + '_Button');

  var searchParams = new _urlSearchParams2.default(window.location.search);

  sortButtons.forEach(function (sortButton) {
    var changeEvent = function changeEvent(event) {
      return handleChange(event, searchParams);
    };
    sortButton.addEventListener('click', changeEvent);
  });
}